'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AvailabilityLink = require('./components/AvailabilityLink.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AvailabilityLink).default;
  }
});
Object.defineProperty(exports, 'AvailabilityLink', {
  enumerable: true,
  get: function get() {
    return _AvailabilityLink.AvailabilityLink;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/availability-link/lib/index.js
// module id = 1172
// module chunks = 0